import type { ECampaignClass, IFeatureMap } from '@feathr/blackbox';
import { ECampaignClass as ECampaignClassEnum } from '@feathr/blackbox';

export type TCampaignRecord = Record<keyof typeof ECampaignClass, boolean> & {
  monetization: boolean;
};

export function createCampaignRecord(
  ads: IFeatureMap['ads'],
  email: IFeatureMap['email'],
  conversations: IFeatureMap['conversations'],
  other: IFeatureMap['other'],
  invites: IFeatureMap['invites'],
  monetization: IFeatureMap['monetization'],
): TCampaignRecord {
  const defaultCampaigns: TCampaignRecord = {
    retargeting: false,
    mobileGeoFencing: false,
    mobileGeoFenceRetargeting: false,
    facebook: false,
    emailListFacebook: false,
    emailList: false,
    search: false,
    seedSegment: false,
    affinity: false,
    googleAdsSmart: false,
    conversation: false,
    landingPage: false,
    singleSend: false,
    smartSend: false,
    autoSend: false,
    drip: false,
    mailrailAutoSend: false,
    mailrailSingleSend: false,
    mailrailDrip: false,
    trackedLink: false,
    invites: false,
    monetization: false,
    omni: false,
  };

  const result = Object.entries({
    ads,
    email,
    conversations,
    other,
    invites,
  }).reduce((acc, [key, value]) => {
    if (['ads', 'email', 'conversations', 'other', 'invites'].includes(key)) {
      const campaignTypes = Object.keys(ECampaignClassEnum) as Array<
        keyof typeof ECampaignClassEnum
      >;
      for (const [featureKey, enabled] of Object.entries(value)) {
        // Not all keys are campaign types.
        const campaignType = campaignTypes.find((k) => ECampaignClassEnum[k] === featureKey);

        if (campaignType) {
          acc[campaignType] = Boolean(enabled);
        }
      }
    }

    return acc;
  }, defaultCampaigns);

  // Set monetization based on sponsoredRetargetingCampaigns
  result.monetization = monetization.sponsoredRetargetingCampaigns === true;

  return result;
}
